import { graphql } from 'react-apollo';
import { Languages } from '../../queries/Languages';

const createOptions = serverResponse =>
  serverResponse.map(item => ({
    key: item[0],
    value: item[1],
    text: item[1]
  })) || [];

const withLanguagesOptions = graphql(Languages, {
  skip: ({ passenger = {}, values = {} }) =>
    !passenger.affiliate && !values.affiliateId,
  options: ({ passenger = {}, values = {} }) => {
    const { affiliate } = passenger;
    const { affiliateId } = values;
    return {
      fetchPolicy: 'cache-first',
      variables: {
        filter: {
          affiliateId: affiliate || affiliateId
        }
      }
    };
  },
  props: ({ data: { allPassengerTicketLanguages, loading, error } }) => ({
    error,
    loading,
    languagesOptions: allPassengerTicketLanguages
      ? createOptions(allPassengerTicketLanguages)
      : []
  })
});

export default withLanguagesOptions;



// WEBPACK FOOTER //
// ./src/component/HOC/withLanguagesOptions.js